// AIDEV-NOTE: Banner MUI para solicitar permissao de push notifications
import { useState, useEffect } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { useAuth } from '../hooks/useAuth';

const DISMISS_KEY = 'push_dismissed';

export function NotificationPermissionBanner() {
  const { permission, isSubscribed, isLoading, isAvailable, subscribe } = usePushNotifications();
  const { isAuthenticated } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(localStorage.getItem(DISMISS_KEY) === 'true');
  }, []);

  // AIDEV-NOTE: Nao mostra o banner se:
  // - Nao esta autenticado
  // - Ja esta inscrito
  // - Permissao ja foi negada
  // - Usuario dispensou o banner
  // - API Notification nao disponivel
  if (
    !isAuthenticated ||
    isSubscribed ||
    permission === 'denied' ||
    dismissed ||
    typeof Notification === 'undefined' ||
    isAvailable !== true
  ) {
    return null;
  }

  // So mostra quando permission === 'default' (nunca perguntado)
  if (permission !== 'default') {
    return null;
  }

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Alert
        severity="info"
        action={
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button color="inherit" size="small" onClick={handleDismiss} disabled={isLoading}>
              Agora nao
            </Button>
            <Button variant="contained" size="small" onClick={subscribe} disabled={isLoading}>
              {isLoading ? 'Ativando...' : 'Ativar'}
            </Button>
          </Box>
        }
      >
        Ative as notificacoes para receber alertas de sincronizacao, leads pendentes e atualizacoes
        da equipe.
      </Alert>
    </Box>
  );
}
